// extracted by mini-css-extract-plugin
module.exports = {"parallelogram":"DiscountBanner_parallelogram__FfbgR","discount":"DiscountBanner_discount__2wLXB"};